import { SubscriberData } from './types';

const parseNumber = (value: unknown): number => {
  if (value === null || value === undefined) return 0;
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? 0 : numericValue;
};

export const transformSubscriberData = (apiData: any): SubscriberData => {
  const clicks = parseNumber(apiData.company?.cliks ?? apiData.company?.clicks);
  const subscribedCount = parseNumber(apiData.company?.subscribed_count);
  const subscribersPercent = clicks > 0 ? (subscribedCount / clicks) * 100 : 0;

  return {
    id: apiData.id,
    name: apiData.name,
    username: apiData.username || '',
    ofUserId: apiData.of_user_id,
    ofModelId: apiData.of_model_id,
    client: apiData.client,
    more3ChatMessages: apiData.more_3_chat_messages,
    transactionsCount: apiData.transactions_count || 0,
    transactionsMaxAmount: apiData.transactions_max_amount || '0',
    createdAt: apiData.created_at,
    company: {
      createdAt: apiData.company.created_at,
      id: apiData.company.id,
      source: apiData.company.source,
      clicks,
      ofId: apiData.company.of_id,
      link: apiData.company.link,
      subscribersPercent,
      type: apiData.company.type,
    },
    model: {
      id: apiData.model.id,
      avatar: apiData.model.avatar,
      name: apiData.model.name,
      ofUserName: apiData.model.of_user_name,
    },
  };
};
